import { ObjectType } from './base';

export type WhiteboardData = {
	id: number;
	objectType: number;
	objectId: number;
	name: string;
	data: string; // JSON string containing Excalidraw data
	createdByUserId: number;
	updatedByUserId: number;
	createdDateUtc: Date;
	updatedDateUtc: Date;
	files: WhiteboardFile[];
};

export type WhiteboardUpdateRequest = {
	id?: number;
	objectType: number;
	objectId: number;
	name: string;
	data: string;
};

// Yjs-based real-time update
export type WhiteboardYjsUpdate = {
	WhiteboardId: number;
	Update: Uint8Array; // Yjs binary update
	UserId: number;
	Timestamp: Date;
};

// Efficient presence message (cursor position, ~20Hz)
export type WhiteboardPresenceMessage = {
	t: 'cursor';
	x: number;
	y: number;
	userId: number;
	userName?: string;
};

// Stroke chunk while drawing
export type WhiteboardStrokeChunk = {
	t: 'strokeChunk';
	id: string;
	points: [number, number, number][]; // [x, y, timestamp]
	pressure?: number[];
	color?: string;
	width?: number;
};

// Stroke end message
export type WhiteboardStrokeEnd = {
	t: 'strokeEnd';
	id: string;
	finalProps?: {
		color?: string;
		width?: number;
		opacity?: number;
	};
};

// Legacy types for compatibility
export type WhiteboardRealTimeUpdate = {
	WhiteboardId: number;
	Data: string;
	UpdatedByUserId: number;
	UpdatedDateUtc: Date;
};

// New types for cache-backed functionality
export type WhiteboardJoinResponse = {
	whiteboard: WhiteboardData | null;
	latestSnapshot: WhiteboardHistoryData | null;
	pendingUpdates: WhiteboardYjsCacheData[];
	cacheAvailable: boolean;
};

export type WhiteboardHistoryData = {
	id: number;
	whiteboardId: number;
	portalId: number;
	snapshotData: string;
	yjsStateVector: string;
	yjsStateUpdate: string;
	version: number;
	createdByUserId: number;
	createdDateUtc: Date;
	isActive: boolean;
};

export type WhiteboardFile = {
	id: string;
	mimeType: string;
	lastRetrieved: number;
	created: number;
	dataURL: string;
};

export type WhiteboardYjsCacheData = {
	updateId: string;
	whiteboardId: number;
	yjsUpdate: string; // byte array as number array from JSON
	updatedByUserId: number;
	updatedByUserName: string;
	timestamp: Date;
	version: number;
};

export type WhiteboardSnapshotRequest = {
	WhiteboardId: number;
	SnapshotData: string;
	YjsStateVector: string;
	YjsStateUpdate: string;
};

export type WhiteboardSaveFileRequest = {
	whiteboardId: number;
	file: WhiteboardFile;
};

export enum WhiteboardSignalREventType {
	JoinGroup = 0,
	LeaveGroup = 1,
	Presence = 2,
	VJS_Update = 3,
	JoinConfirmed = 4,
	FilesUpdated = 5,
}

export type WhiteboardSignalREvent = {
	EventType: WhiteboardSignalREventType;
	ObjectType: ObjectType;
	ObjectId: number;
	WhiteboardId?: number;
	Content?: unknown;
	OriginConnectionId?: string;
};

export type CollaboratorCursor = {
	x: number;
	y: number;
	userId: number;
	userName?: string;
	lastSeen: number;
};
